/* eslint-disable react-hooks/exhaustive-deps */
import styled from 'styled-components';
import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatchToStore, useSelectorToStore } from '@hooks/reduxHooks';
import { useRouter } from 'next/router';
import { checkCoursesEnrollStatus } from '@actions/courses';
import {
  ProdigyHeader,
  HowToCrack,
  GoalWiseTestSeries,
  StarPoints,
  EducatorsList,
  ShareBlock,
  AboutProdigy,
  ProdigyFAQs,
  AppInstall
} from '.';
import ProdigyTestCard from './ProdigyTestCard';
import ProdigyClassCard from './ProdigyClassCard';

const Wrapper = styled.div`
  width: 100vw;
  margin-top: 100px;
  @media only screen and (max-width: 540px) {
    width: 100vw;
    overflow-x: hidden;
    margin-top: 56px;
  }
`;

const ProdigyContainer = ({ data }) => {
  const goalList = useRef();
  const dispatch = useDispatchToStore();
  const router = useRouter();
  const me = useSelectorToStore((state) => state.auth.me);

  const { testSeriesUIDs } = data;

  useEffect(() => {
    if (me.username) {
      dispatch(checkCoursesEnrollStatus(testSeriesUIDs));
    }
  }, [dispatch, me.username]);

  const onEnrollNowClick = () => {
    // const offset = goalList.current?.offsetTop - 50;
    // window.scrollTo({
    //   top: offset,
    //   behaviour: 'smooth'
    // });
    document
      .getElementById('goalwise-testseries')
      .scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const hasTests = Object.keys(data.tests).length > 0;
  const hasClasses = Object.keys(data.classes).length > 0;

  return (
    <Wrapper>
      <ProdigyHeader dataSet={data} />
      <HowToCrack enrollNow={onEnrollNowClick} dataSet={data} />
      {hasTests && (
        <GoalWiseTestSeries
          ref={goalList}
          items={data.tests}
          goalData={data.goalData}
          id="goalwise-testseries"
          title="Pick the right test for you"
          Card={ProdigyTestCard}
          data={data}
        />
      )}
      {hasClasses && (
        <GoalWiseTestSeries
          ref={goalList}
          items={data.classes}
          goalData={data.goalData}
          title="Pick the right class for you"
          Card={ProdigyClassCard}
          id="goalwise-testseries"
          data={data}
        />
      )}
      <StarPoints enrollNow={onEnrollNowClick} dataSet={data} />
      <EducatorsList
        enrollNow={onEnrollNowClick}
        disable={router.route !== 'prodigy'}
      />
      <ShareBlock dataSet={data} />
      <AboutProdigy enrollNow={onEnrollNowClick} dataSet={data} />
      <ProdigyFAQs enrollNow={onEnrollNowClick} dataSet={data} />
      <AppInstall />
    </Wrapper>
  );
};

ProdigyContainer.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired
};

export default ProdigyContainer;
